{
  "culture": "es",
  "texts": {
    "AbpUi": {
      "Close": "Cerrar",
      "Hours": "Horas",
      "Minutes": "Minutos",
      "Seconds": "Segundos",
      "First": "Primero",
      "Previous": "Anterior",
      "Next": "Siguiente",
      "Last": "Último",
      "SelectMonth": "Seleccionar mes",
      "SelectYear": "Seleccionar año",
      "PreviousMonth": "Mes anterior",
      "NextMonth": "Mes siguiente",
      "IncrementHours": "Incrementar horas",
      "DecrementHours": "Decrementar horas",
      "IncrementMinutes": "Incrementar minutos",
      "DecrementMinutes": "Decrementar minutos",
      "IncrementSeconds": "Incrementar segundos",
      "DecrementSeconds": "Decrementar segundos"
    },
    "AbpTable": {
      "Sort": "Ordenar",
      "Ascending": "Ascendente",
      "Descending": "Descendente",
      "Filter": "Filtro",
      "SelectAll": "Seleccionar todo",
      "ClearFilters": "Limpiar filtros",
      "ApplyFilters": "Aplicar filtros"
    },
    "TourType": {
      "ConfirmDelete": "¿Está seguro que desea eliminar el tipo de recorrida?",
      "DeleteSuccess": "Tipo de recorrida eliminado con éxito",
      "DeleteError": "Ocurrió un error eliminando el tipo de recorrida",
      "UpdateSuccess": "Tipo de recorrida actualizado con éxito",
      "CreateSuccess": "Tipo de recorrida creado con éxito"
    },
    "Tour": {
      "DeleteSuccess": "Recorrida eliminada correctamente",
      "DeleteError": "Error al eliminar la recorrida",
      "FormSaved": "Formulario guardado",
      "UserModifiedSuccess": "Usuario modificado",
      "UserModifyError": "Error al modificar el usuario",
      "SaveFormError": "Error al guardar el formulario",
      "CreateSuccess": "Recorrida creada correctamente",
      "FillRequiredFields": "Rellene los campos requeridos",
      "ErrorSavingForm": "Error al guardar el formulario",
      "OfflineFormSaved": "Los datos se guardarán cuando vuelva a tener conexión",
      "TourDeleted": "Recorrida eliminada correctamente",
      "ErrorDeletingTour": "Error al eliminar la recorrida",
      "ConfirmModifyResponsible": "¿Desea modificar el responsable de la recorrida?",
      "AnswerTitle": "Responder recorrida",
      "AnswerSelectAtLeastOneOption": "Debe seleccionar al menos una opcion",
      "AnswerNoFieldsToShow": "No hay campos para mostrar",
      "AnswerNoUnassignedActionsToShow": "No hay acciones sin asignar para mostrar",
      "AnswerShowOnlyUnassignedActions": "Mostrar solo acciones sin asignar",
      "AnswerUnassignedActionsCount": "Acciones sin asignar",
      "AnswerCancelButton": "Cancelar",
      "AnswerSaveButton": "Guardar",
      "AnswerFieldStatus": "Estado",
      "AnswerSelectAtLeastOneAction": "Debe seleccionar al menos una accion",
      "AnswerFieldActions": "Acciones",
      "AnswerMustEnterNumber": "Debe ingresar un numero",
      "AnswerActionWithoutResponsible": "Accion sin responsable",
      "AnswerFilesAndDocuments": "Archivos y documentos",
      "AnswerNoAttachedFiles": "No hay archivos adjuntos",
      "AnswerAddComment": "Agregar comentario",
      "AnswerUnassignedWarningTitle": "Acciones sin asignar",
      "AnswerUnassignedWarningDescription": "Hay acciones sin responsable. Si continua, se guardara igualmente.",
      "AnswerUnassignedWarningCancel": "Volver",
      "AnswerUnassignedWarningConfirmAndSave": "Guardar de todas formas",
      "AnswerUnassignedWarningDefaultItem": "Atributo {0}",
      "AnswerUnassignedWarningDefaultAction": "Accion {0}"
    },
    "Form": {
      "IntroduceName": "Introduzca un nombre",
      "SelectUnitOfMeasure": "Debe seleccionar una unidad de medida",
      "ErrorLoadingForm": "Error al cargar el formulario",
      "ErrorUpdatingForm": "Error al actualizar el formulario",
      "ErrorCreatingForm": "Error al crear el formulario",
      "IncompleteForm": "Formulario incompleto",
      "MandatoryActionWithoutAllowAction": "No puede haber acciones obligatorias sin acciones permitidas",
      "UpdatedSuccess": "Formulario actualizado exitosamente",
      "CreatedSuccess": "Formulario creado exitosamente",
      "FormCreated": "Formulario creado exitosamente"
    },
    "Action": {
      "NoUsersFound": "No se encontraron posibles usuarios",
      "OnlyImagesOrPdfAllowed": "Solo se permiten imágenes o PDF",
      "OperationSuccess": "Operación exitosa",
      "UpdateSuccess": "La acción se ha actualizado correctamente",
      "SavedSuccessfully": "Acción guardada correctamente",
      "ActionSavedSuccessfully": "Acción guardada exitosamente",
      "ErrorSavingAction": "Error al guardar la acción",
      "ReviewSavedSuccess": "Revisión guardada exitosamente",
      "Complete": "Completar",
      "Review": "Revisión",
      "Details": "Detalles",
      "ConfirmModifyResponsible": "¿Desea modificar el responsable de la acción?",
      "ErrorModifyingUser": "Error al modificar el usuario"
    },
    "User": {
      "Created": "Usuario creado",
      "AssignedSuccessfully": "Usuario asignado correctamente"
    },
    "TourReport": {
      "CombineSyncMessage": "La combinación se sincronizará al enviar la respuesta al formulario",
      "CombineSuccess": "Las recorridas seleccionadas se han combinado correctamente."
    },
    "Error": {
      "ErrorCreatingTourType": "Ocurrió un error creando el tipo de recorrida",
      "ErrorUpdatingTourType": "Ocurrió un error actualizando el tipo de recorrida",
      "NameRequired": "El nombre es obligatorio",
      "PlanRequired": "Debe seleccionar un plan",
      "DaysBeforeAlertRequired": "Los días antes de la alerta son obligatorios",
      "DaysBeforeAlertMin": "Los días antes de la alerta deben ser mayores a 0",
      "ProcessRequired": "Debe seleccionar un proceso",
      "TimeToRealizeJobRequired": "El tiempo para realizar la recorrida es obligatorio",
      "TimeToRealizeJobMin": "El tiempo para realizar el trabajo debe ser mayor a 0",
      "CreateUserError": "Error al crear usuario",
      "InvalidUsernameOrPassword": "Nombre de usuario o contraseña inválidos",
      "PasswordMustBeSame": "Las contraseñas no coinciden"
    },
    "Validation": {
      "SelectAtLeastTwoTourReportsToCombine": "Debe seleccionar al menos dos recorridas para combinar.",
      "TourReportsMustBeOfSameType": "Las recorridas deben ser del mismo tipo.",
      "SelectAtLeastOneActionForField": "Debe seleccionar una acción en el atributo {0}",
      "SelectAtLeastOneOption": "Debe seleccionar al menos una opción en todo el formulario",
      "ReviewAlreadyExistsForAction": "Ya existe una revisión para esta acción",
      "FormResponseAlreadyExistsForAction": "Ya existe una revisión para esta acción"
    },
    "File": {
      "DeleteFileConfirmation": "¿Está seguro de que desea eliminar el archivo {0}?",
      "TotalFilesSizeExceeded": "El tamaño total de los archivos excede el tamaño máximo permitido de {0} MB",
      "DuplicateFileName": "El archivo {0} ya está cargado, no se puede cargar el mismo archivo dos veces"
    }
  }
}